<template>
    <span v-if="rows && rows.length">
      <span class="taggle" v-for="row in rows" :key="row">{{ row }}</span>
    </span>
    <span v-else class="taggle"><slot /></span>
</template>
<script>
export default {
    name: 'Taggle',
    props: {
        rows: {
            type: Array,
            required: false,
        },
    },
}
</script>
<style scoped lang="scss">
.taggle {
  background-color: #F0F1F3;
  border-radius: 6px;
  color: #333333;
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  padding: 8px 12px;
  white-space: nowrap;
  margin-right: 4px;
  &:last-child {
    margin-right: 0;
  }
}
</style>